import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { Grid } from '@material-ui/core';

import FeeTotal from '../../../../models/FeeTotal';
import AddServicesUnits from '../../../../models/AddServicesUnits';

import storageStyles from '../storage/storage.module.css';
import commonAddServiceStyles from '../commonAdditionalService/commonAdditionalService.module.css';
import commonStyles from '../../../common/common.module.css';
import { formatCurrency } from '../../../../utils/currencyFormatter';

const TEXT_FIELD_PADDINGS: string = '8px 12px';
const styles = (theme: any) => ({

});

interface PerishableStorageProps {
  classes: any;
  serviceDetails: AddServicesUnits;
  arrivalDate: string;
  pickupDate: string;
  total: number;
  calculations: FeeTotal;
  cartItemWeight: number;
  handleChange: any;
  additionalInformation: string;
  disabled: boolean;
};

const perishableStorage = (props: PerishableStorageProps) => {

  const { classes, serviceDetails, arrivalDate, pickupDate, total, calculations, cartItemWeight, handleChange, additionalInformation } = props;

  return (
    <FormControl fullWidth={ true }>
      <Grid container className={ commonAddServiceStyles.gridContainer }>
        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <div className={ commonStyles.inputLabelWrapper } >
            <label className={ commonStyles.inputLabel }>  AWB Received Date </label>
            <TextField
              disabled
              value={ arrivalDate }
              label=""
              variant="outlined"
              inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                            style: { padding: TEXT_FIELD_PADDINGS }
                          }} 
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
              fullWidth
            />
          </div>
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <div className={ commonStyles.inputLabelWrapper } >
            <label className={ commonStyles.inputLabel }>  Scheduled Pick Up </label>
            <TextField
              disabled
              value={ pickupDate }
              label=""
              variant="outlined"
              inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                            style: { padding: TEXT_FIELD_PADDINGS }
                          }} 
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
            />
          </div>
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }>  Storage Days </label>
          <TextField
            disabled
            label=""
            value={ calculations.days }
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }>  Cost per kg per day </label>
          <TextField
            disabled
            label=""
            defaultValue={ formatCurrency(serviceDetails ? serviceDetails.cost_per_kg_per_day_usd : 0, 2, '$') }
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> Total AWB weight  </label>
          <TextField
            disabled
            value={ cartItemWeight }
            label=""
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> Total cost for weight  </label>
          <TextField
            disabled
            label=""
            value={ formatCurrency(calculations.total_cost_for_weight || 0 , 2, '$') }
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>
        </Grid>

        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }>  MIN Cost per day </label>
          <TextField
            disabled
            label=""
            defaultValue={ formatCurrency(serviceDetails ? serviceDetails.cost_per_day_min_usd : 0, 2, '$') }
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>
        </Grid>
        <Grid item md={4} sm={4} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> Total MIN cost  </label>
          <TextField
            disabled
            label=""
            value={ formatCurrency(calculations.total_min_cost || 0, 2, '$') }
            variant="outlined"
            inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                          style: { padding: TEXT_FIELD_PADDINGS }
                        }}
            InputLabelProps={{ style: { fontWeight: 'bold' } }}
          />
        </div>
        </Grid>
        <Grid item sm={8} xs={6} direction="row" className={ `${ commonAddServiceStyles.gridItem } ${ commonStyles.fvMiddle }  ${ commonStyles.pb0 }` }>
          <div className={ storageStyles.horizontalLine }></div>
        </Grid>
        <Grid item sm={4} xs={6} direction="row" className={ commonAddServiceStyles.gridItem }>
          <div className={ commonStyles.inputLabelWrapper } >
            <label className={ commonStyles.inputLabel }>  Total Cost </label>
            <TextField
              disabled
              label=""
              value={ formatCurrency(total, 2, '$') }
              variant="outlined"
              inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                            style: { padding: TEXT_FIELD_PADDINGS }
                          }}
              InputLabelProps={{ style: { fontWeight: 'bold' } }}
            />
          </div>
        </Grid>
        <Grid item sm={12} xs={12} direction="row" className={ commonAddServiceStyles.gridItem }>
          <div className={ storageStyles.addInfoWrapper }>
            <div className={ commonStyles.inputLabelWrapper } >
              <label className={ commonStyles.inputLabel }> Additional information to GHA  </label>
              <TextField
                fullWidth={ true }
                id="outlined-disabled"
                label=""
                variant="outlined"
                onChange={ (event) => props.handleChange(event, 'additionalInformation') }
                value={ additionalInformation }
                inputProps={{ classes: { notchedOutline: classes.overrideBorder },
                              style: { padding: TEXT_FIELD_PADDINGS }
                            }}
                InputLabelProps={{ shrink: true }}
                disabled={ props.disabled }
              />
            </div>
          
          </div>
        </Grid>
      </Grid> 
    </FormControl>
  );
}

export default withStyles(styles)(perishableStorage);